// index.ts
import polygonClipping from "polygon-clipping";
import { polygon, multiPolygon } from "@turf/helpers";
import { geomEach } from "@turf/meta";
function difference(features) {
  const geoms = [];
  geomEach(features, (geom) => {
    geoms.push(geom.coordinates);
  });
  if (geoms.length < 2) {
    throw new Error("Must have at least two features");
  }
  const properties = features.features[0].properties || {};
  const differenced = polygonClipping.difference(geoms[0], ...geoms.slice(1));
  if (differenced.length === 0)
    return null;
  if (differenced.length === 1)
    return polygon(differenced[0], properties);
  return multiPolygon(differenced, properties);
}
var turf_difference_default = difference;
export {
  turf_difference_default as default,
  difference
};
//# sourceMappingURL=index.js.map